/*
 * Copyright (C) 2022 neocotic
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { WebDomElement } from "./WebDomElement";
import { WebDomNode } from "./WebDomNode";
import { WebDomRoot } from "./WebDomRoot";
/**
 * An implementation of {@link Dom} for a web browser.
 */
export class WebDom {
    createElement(element, root) {
        return new WebDomElement({
            dom: this,
            node: element,
            root,
        });
    }
    createNode(node, root) {
        if (this.isElement(node, root)) {
            return this.createElement(node, root);
        }
        if (this.isRoot(node, root)) {
            return root;
        }
        return new WebDomNode({
            dom: this,
            node,
            root,
        });
    }
    createRoot(contents) {
        const bodyNode = document.createElement('span');
        if (typeof contents === 'string') {
            bodyNode.innerHTML = contents;
        }
        else if (Array.isArray(contents)) {
            bodyNode.append(...contents);
        }
        else {
            bodyNode.appendChild(contents);
        }
        const rootNode = document.createDocumentFragment();
        rootNode.appendChild(bodyNode);
        return new WebDomRoot({
            dom: this,
            node: rootNode,
        });
    }
    isElement(node, root) {
        return node.nodeType === Node.ELEMENT_NODE;
    }
    isRoot(node, root) {
        return node === root.node();
    }
    isText(node, root) {
        return node.nodeType === Node.TEXT_NODE;
    }
}
//# sourceMappingURL=WebDom.js.map